// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer___zlGl","resendInfoText":"OnGoingPaymentBox_resendInfoText__39SSQ"};